export * from './site-juridiction.model';



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/site-juridiction/index.ts